module.exports = __webpack_public_path__ + "img/slider_8.d66d7794.jpg";